import { Params } from '@angular/router';
import { LanguageService } from '@services/language/language.service';
import { LanguagesEnum } from '@core/config';

export class HttpHelper {
  static compareObjects<T>(a: T, b: T): boolean {
    try {
      return JSON.stringify(a) === JSON.stringify(b);
    } catch (e) {
      return false;
    }
  }

  static buildUrl(path: string = null, queryParams?: Params, fragment?: string): string | null {
    if (!path) {
      return null;
    }

    const url = new URL(path);

    Object.entries(queryParams || {}).forEach(([key, value]) => url.searchParams.append(key, value.toString()));

    url.hash = fragment ?? '';

    return url.toString();
  }

  static getLocalizedPath(path: string = ''): string {
    const selectedLanguage = LanguageService.selectedLanguage || LanguagesEnum.EN;

    if (path.length > 1) {
      path = path.startsWith('/') ? path.slice(1) : path;
    }

    return ['/', selectedLanguage.toLowerCase(), path].join('/').replaceAll(/\/\//g, '/');
  }

  static isRootPath(path: string = ''): boolean {
    const languages = Object.keys(LanguagesEnum).map(lang => lang.toLowerCase());
    const regex = RegExp(`^\/(${languages.join('|')})\/?$`);

    return regex.test(path);
  }

  static extractYoutubeVideoId(videoUrl: string = ''): string {
    if (!videoUrl.includes('?v=')) {
      return videoUrl.split('/').at(-1);
    }

    const regex: RegExp = /v=([a-zA-Z0-9-_]+)/;

    if (regex.test(videoUrl)) {
      const result = regex.exec(videoUrl)?.[1];

      if (result) {
        return result;
      }
    }

    const part = videoUrl.split('?v=').at(-1);

    if (part.includes('&')) {
      return part.split('&')?.[0];
    }

    return part;
  }
}
